<template>
  <div>
    <Transition name="fade">
      <div v-if="isVisible" class="backdrop" @click="handleClose"></div>
    </Transition>
    <Transition name="fade">
      <div v-if="isVisible" class="submenu" id="spec-sub-menu">
        <h1 v-if="menuTitle" class="menu-title">{{ menuTitle }}</h1>
        <template v-if="submenu.length > 0">
          <template v-for="(spec, index) in submenu" :key="index">
            <slot :spec="spec" :index="index" />
          </template>
        </template>
        <template v-else>
          <slot />
        </template>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  props: {
    menuTitle: {
      type: String,
      default: ''
    },
    submenu: {
      type: Array,
      required: false,
      default: []
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: false,
      shouldRemove: false
    }
  },
  mounted() {
    // Only show if prop says so
    if (this.show) {
      this.$nextTick(() => {
        this.isVisible = true
        this.adjustPosition()
      })
    }
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          // Parent wants to show, trigger fade-in
          this.$nextTick(() => {
            this.isVisible = true
            this.adjustPosition()
          })
        } else {
          // Parent wants to hide, trigger fade-out
          this.isVisible = false
        }
      },
      immediate: false
    }
  },
  methods: {
    handleClose() {
      this.isVisible = false
      setTimeout(() => {
        this.$emit('close')
      }, 200)
    },
    adjustPosition() {
      this.$nextTick(() => {
        const submenu = this.$el.querySelector('.submenu')
        if (!submenu) return

        const viewportHeight = window.innerHeight
        const viewportWidth = window.innerWidth

        // Reset any previous adjustments
        submenu.style.top = '-30px'
        submenu.style.left = '50%'

        // Check boundaries after resetting
        const rect = submenu.getBoundingClientRect()

        // Adjust vertical position if menu goes outside viewport
        if (rect.top < 0) {
          // Menu goes above viewport - move it down
          submenu.style.top = '10px'
        } else if (rect.bottom > viewportHeight) {
          // Menu goes below viewport - move it up
          const newTop = viewportHeight - rect.height - 20
          submenu.style.top = `${newTop - rect.top}px`
        }

        // Adjust horizontal position if menu goes outside viewport
        if (rect.left < 20) {
          // Menu goes off left edge
          submenu.style.left = '20px'
          submenu.style.transform = 'none'
        } else if (rect.right > viewportWidth - 20) {
          // Menu goes off right edge
          submenu.style.left = 'auto'
          submenu.style.right = '20px'
          submenu.style.transform = 'none'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.backdrop {
  // position: absolute;
  left: 0%;
  top: 0;
  width: 100%;
  height: 100%;
}

.menu-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 15px;
}

.submenu {
  border-radius: 10px;
  position: absolute;
  z-index: 25;
  box-shadow: rgba(96, 96, 96, 0.2) 0 4px 23px;
  width: 300px;
  top: -30px;
  background: white;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px;
  max-height: calc(100vh - 60px);
  overflow: auto;

  /* Zorg dat het menu binnen de viewport blijft */
  max-width: calc(100vw - 40px);

  /* Als het menu boven het scherm uitkomt, duw het naar beneden */
  @media (max-height: 600px) {
    top: 10px;
  }

  :deep(.spec-button) {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
